export const SET_CITY_COLLECTION = 'CORE/SET_CITY_COLLECTION';
